<form (ngSubmit)="onStartFreeTrialSubmit()" class="email-collector-form" *ngIf="vm$ | async as vm" [class.arabic]="currentLang === 'ar'">
  <div class="inputs-container">
    <div class="input-container email">
      <input
        #emailInput
        data-testid="LandingPage.inputField"
        class="email-input"
        [class.light-theme]="theme === 'light'"
        [@borderRadiusAnimation]="vm.showPasswordInput ? 'rectangular' : 'round'"
        [class.error]="vm.emailErrorMessage || vm.gatewayErrorMessage"
        [class.focused-bg]="!!emailFormControl.value.length || (!emailFormControl.value.length && isFocusInProgress)"
        type="text"
        [placeholder]="inputPlaceholder"
        [formControl]="emailFormControl"
        [value]="emailFormControl.value"
      />
      <div class="absolute-icon-container">
        <svg-icon *ngIf="vm.emailErrorMessage" key="exclamation-in-circle"></svg-icon>
        <svg-icon *ngIf="(vm.showPasswordInput && !vm.emailErrorMessage) || showTickMark" key="tickmark-in-circle-filled"></svg-icon>
      </div>
    </div>
    <div class="input-container password" [@passwordInputAnimation]="vm.showPasswordInput ? 'show' : 'hide'">
      <input
        #passwordInput
        class="password-input"
        [class.light-theme]="theme === 'light'"
        [class.focused]="!!passwordFormControl.value?.length"
        [class.error]="vm.gatewayErrorMessage"
        type="{{ isPasswordVisible ? 'text' : 'password' }}"
        [placeholder]="passwordPlaceholder"
        [formControl]="passwordFormControl"
        [value]="passwordFormControl.value"
      />
      <div (click)="onEyeClick()" class="absolute-icon-container eyes">
        <ng-container *ngIf="isPasswordVisible; else hidden"><svg-icon key="eye-closed"></svg-icon></ng-container>
        <ng-template #hidden><svg-icon key="eye"></svg-icon></ng-template>
      </div>
    </div>
  </div>
  <div *ngIf="vm.gatewayErrorMessage || vm.emailErrorMessage || isPasswordTooShort" class="error-hint-container">
    <p class="error hint">
      {{ vm.gatewayErrorMessage || vm.emailErrorMessage | translate }}
    </p>
    <p class="hint" *ngIf="isPasswordTooShort">
      {{ 'Subscription_password_length_hint' | translate }}
    </p>
  </div>
  <ng-content></ng-content>
  <button
    type="submit"
    (click)="onStartFreeTrialSubmit()"
    class="marketing-button email-collector-submit-button"
    data-testid="LandingPage.startFreeTrialButton"
    [disabled]="
      vm.gatewayErrorMessage ||
      vm.emailErrorMessage ||
      (showLoadingSpinner$ | async) ||
      isPasswordTooShort ||
      isPasswordEmpty ||
      isEmailFormatInvalid ||
      isAdditionalInputInvalid
    "
  >
    <span [class.d-none]="showLoadingSpinner$ | async">{{ buttonText | translate }}</span>
    <div class="d-none" [class.d-flex]="showLoadingSpinner$ | async">
      <osn-shared-loading-spinner [size]="25" type="white"></osn-shared-loading-spinner>
    </div>
  </button>
    <span class="email-collector-free-trial" [innerHTML]="emailCollectorPackageInformation | emailCollectorFreeTrial"
      *ngIf="freeTrialTextEnabled && emailCollectorPackageInformation"></span>
  <ng-container *ngIf="showAgreementTextBelowCtaButton" [ngTemplateOutlet]="termsAndPrivacy"></ng-container>
  <ng-container *ngIf="!hideMobileProviderButton && showMobileProviderButton$ | async">
    <div class="separator-container">
      <div class="separator first"></div>
      <div class="separator-text">{{ 'Email_Collector_separator_text' | translate }}</div>
      <div class="separator second"></div>
    </div>
    <a [href]="signUpWithMobileProviderLink" target="_blank" rel="noopener noreferrer" class="mobile-provider-link">
      <button type="button" class="marketing-button mobile-provider" (click)="onSignUpWithMobileProviderClick()">
        {{ 'Email_Collector_mobile_provider_btn' | translate }}
      </button>
    </a>
  </ng-container>
</form>
<div *ngIf="!showAgreementTextBelowCtaButton" class="mt-2 mt-sm-3 bottom-agreement-container">
  <ng-container [ngTemplateOutlet]="termsAndPrivacy"></ng-container>
</div>

<ng-template #termsAndPrivacy>
  <p class="agreement-text centered-text">
    {{ 'Redeem_Agreement_txt' | translate | translateCut: 0 }}
    <a class="brb-link" [href]="termsAndConditionsLink" target="_blank" data-testid="MarketingLandingPage.terms">{{
      'Redeem_Agreement_txt' | translate | translateCut: 1
    }}</a>
    {{ 'Redeem_Agreement_txt' | translate | translateCut: 2 }}
    <a class="brb-link" [href]="privacyPolicyLink" target="_blank" data-testid="MarketingLandingPage.privacy">{{
      'Redeem_Agreement_txt' | translate | translateCut: 3
    }}</a>
  </p>
</ng-template>
